import React from 'react';
import { useLocation } from 'react-router-dom';
import MessageCenter from '../components/communications/MessageCenter';
import { MESSAGE_TEMPLATES } from '../constants/messageTemplates';

const MessagingPage = () => {
  const location = useLocation();
  const phoneNumber = location.state?.phoneNumber;

  // Si un numéro de téléphone est fourni, on le définit dans le MessageCenter
  React.useEffect(() => {
    if (phoneNumber) {
      const event = new CustomEvent('setPhoneNumber', {
        detail: { phoneNumber }
      });
      window.dispatchEvent(event);
    }
  }, [phoneNumber]);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Centre de Messagerie</h1>
      <MessageCenter templates={MESSAGE_TEMPLATES} />
    </div>
  );
};

export default MessagingPage;
